// Transaction detail page (no).
window.PlummeI18n.register('no', {
  'transaction.annulBy': 'Annullert av',
  "transaction.annulAudit": "Annulleringshistorikk",
  "transaction.annulledAt": "Annulleringstidspunkt",
  "transaction.annulReason": "Begrunnelse",
  "transaction.annulActor": "Bruker-ID",
  "transaction.reversalDate": "Motposteringens regnskapsdato",
  "transaction.openOriginal": "Åpne originalpostering",
  "transaction.openReversal": "Åpne motpostering",
  "transaction.auditMissing": "Ikke registrert",
  "transaction.reversalMissing": "Motposteringen er ikke tilgjengelig i den innleste journalen.",
  "transaction.auditDebit": "Debet",
  "transaction.auditCredit": "Kredit",

  'transaction.incompleteBasis': 'Journaldekningen er ufullstendig. Dette bilaget vises for dokumentasjon og diagnostikk; totalene må ikke tolkes som fullstendige.',
  'transaction.journalLoading': 'Regnskapsjournalen hentes. Bilaget vises når den er lest.',
  'route.transaction': 'Transaksjon',
  'transaction.back': 'Tilbake til alle transaksjoner',
  'transaction.title': 'Transaksjon',
  'transaction.posting': 'Postering',
  'transaction.summary': 'Oppsummering – beløp inn og ut fra kontoer',
  'transaction.account': 'Konto',
  'transaction.incoming': 'Inn på konto',
  'transaction.outgoing': 'Ut fra konto',
  'transaction.total': 'Sum',
  'transaction.description': 'Beskrivelse',
  'transaction.links': 'Tilknyttede poster',
  'transaction.sourceLead': 'Dette er bokføring av',
  'transaction.sourceHelp': 'Åpne kilden hvis du skal gjøre endringer i transaksjonen eller en tilknyttet betaling.',
  'transaction.relatedPayments': 'Relaterte betalinger',
  'transaction.correctionReplacement': 'Erstatningsbilag',
  'transaction.correctionOriginal': 'Opprinnelig bilag',
  'transaction.correctionReason': 'Årsak til korrigering',
  'transaction.created': 'Opprettet',
  'transaction.by': 'av',
  'transaction.vatCodes': 'MVA-koder',
  'transaction.accountNumber': 'Kontonr.',
  'transaction.name': 'Navn',
  'transaction.amount': 'Beløp',
  'transaction.documentation': 'Dokumentasjon',
  'transaction.generatedDocument': 'Fakturadokumentet genereres når du åpner eller laster det ned.',
  'transaction.noDocumentation': 'Ingen dokumentasjon er lagt ved denne transaksjonen.',
  'transaction.open': 'Åpen postering',
  'transaction.locked': 'Låst postering',
  'transaction.annulled': 'Annullert',
  'transaction.fallbackType': 'Postering',
  'transaction.notFound': 'Fant ikke transaksjonen',
  'transaction.notFoundHelp': 'Transaksjonen kan være annullert, tilhøre et annet regnskapsår eller ikke lenger være tilgjengelig.',
  'transaction.invoice': 'Faktura',
  'transaction.purchase': 'Kjøp',
  'transaction.otherSale': 'Annet salg',
  'transaction.customs': 'Tolldeklarasjon',
  'transaction.openDocument': 'Se bilag',
  'transaction.download': 'Last ned',
  'transaction.upload': 'Last opp vedlegg',
  'transaction.uploaded': 'Vedlegg lastet opp.',
  'transaction.uploadFailed': 'Kunne ikke laste opp vedlegget.',
  'transaction.documentFailed': 'Kunne ikke hente bilaget fra backend.',
  'transaction.previewFailed': 'Kunne ikke vise bilaget.',
  'transaction.lost': 'Bilag borte',
  'transaction.lostPrompt': 'Forklaring til loggen (valgfritt):',
  'transaction.lostSaved': 'Bilaget er merket som borte.',
  'transaction.lostFailed': 'Kunne ikke markere bilaget som borte.',
  'transaction.annul': 'Annuller transaksjon',
  'transaction.annulQuestion': 'Annuller transaksjon?',
  'transaction.creditQuestion': 'Krediter faktura?',
  'transaction.credit': 'Krediter',
  'transaction.annulling': 'Annullerer...',
  'transaction.annulHelp': 'Transaksjonen annulleres og beholdes som historikk, men tas ikke med i rapportgrunnlaget.',
  'transaction.creditHelp': 'Fakturaen krediteres med en kreditnota som opprettes som utkast for kontroll før sending.',
  'transaction.creditDraft': 'Kreditnota er opprettet som utkast. Kontroller og send den fra fakturalisten.',
  'transaction.annulledSaved': 'Transaksjonen er annullert.',
  'transaction.annulFailed': 'Kunne ikke annullere transaksjonen.',
  'transaction.privateReimbursed': 'Det private utlegget er refundert.',
  'transaction.privateReimburseFailed': 'Kunne ikke refundere det private utlegget.',
  'transaction.reimbursePrivate': 'Refunder privat utlegg',
  'transaction.reimbursePrivateHelp': 'Bokfører refusjonen fra valgt firmabankkonto mot konto 2060 uten å føre kostnad eller MVA på nytt.',
  'transaction.paymentDate': 'Betalingsdato',
  'transaction.bankAccount': 'Bankkonto',
  'transaction.goTo': 'Gå til',
  'transaction.bank': 'Bank',
  'transaction.vat': 'MVA',
  'transaction.yearEnd': 'Årsavslutning',
});
